// ---- D420 (owner decisions D408 #12, D422): retire a country pack under four eyes -----------------------------
/** Why a pack is retired — the closed vocabulary the server accepts (mirrors `@vello/config`). */
export const COUNTRY_PACK_RETIRE_REASON_CODES = ['pack_country_exit', 'pack_registered_in_error', 'pack_test_registration', 'pack_superseded', 'pack_other'];
export class ConfigApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /** Publish a new policy version (S113). The server assigns the next monotonic version. */
    publishPolicy(input) {
        return this.client.request({ method: 'POST', path: '/v1/config/policies', body: input, auth: true });
    }
    /** The version history for a policy key (diff / rollback). */
    policyHistory(key) {
        return this.client.request({ method: 'GET', path: `/v1/config/policies/${encodeURIComponent(key)}`, auth: true });
    }
    /** Preview how a key resolves in a scope context at an instant. `context` keys are scope names. */
    resolvePolicy(key, context = {}, at) {
        const params = new URLSearchParams();
        for (const [scope, ref] of Object.entries(context))
            if (ref !== undefined)
                params.set(scope, ref);
        if (at !== undefined)
            params.set('at', at);
        const qs = params.toString();
        return this.client.request({ method: 'GET', path: `/v1/config/policies/${encodeURIComponent(key)}/resolve${qs !== '' ? `?${qs}` : ''}`, auth: true });
    }
    // ---- country packs (ADR-0033) ------------------------------------------------------------------
    /** Register a country as a new DRAFT pack version (the server assigns the next monotonic version). */
    createCountryPackDraft(input) {
        return this.client.request({ method: 'POST', path: '/v1/config/country-packs', body: input, auth: true });
    }
    /**
     * The version history for a country (DRAFT/APPROVED/RETIRED state, currency, locale, audit). D420: plus its retirement
     * proposals and the governance audit (absent on a server before D420).
     */
    listCountryPacks(countryCode) {
        return this.client.request({ method: 'GET', path: `/v1/config/country-packs/${encodeURIComponent(countryCode)}`, auth: true });
    }
    /**
     * D420 review W7G-01: every PENDING retirement, platform-wide, newest first (`config:view`) — the checker's read. A
     * retirement targets a country with no live market, often one with no market at all, so walking the market catalog
     * never finds it.
     */
    listPendingCountryPackRetirements() {
        return this.client.request({ method: 'GET', path: '/v1/config/country-packs/retirements/pending', auth: true });
    }
    /** D420: the MAKER proposes retiring an APPROVED version (`409 PACK_COUNTRY_HAS_MARKETS` while a market is not RETIRED). */
    proposeCountryPackRetirement(countryCode, input) {
        return this.client.request({ method: 'POST', path: `/v1/config/country-packs/${encodeURIComponent(countryCode)}/retire`, body: input, auth: true });
    }
    /** D420: a DIFFERENT operator approves the retirement (`403 FOUR_EYES_SELF_APPROVAL` for the proposer); the pack becomes RETIRED. */
    approveCountryPackRetirement(countryCode, input) {
        return this.client.request({ method: 'POST', path: `/v1/config/country-packs/${encodeURIComponent(countryCode)}/retire/approve`, body: input, auth: true });
    }
    /** D420: close the pending retirement without retiring (the proposer may withdraw its own). */
    rejectCountryPackRetirement(countryCode, input) {
        return this.client.request({ method: 'POST', path: `/v1/config/country-packs/${encodeURIComponent(countryCode)}/retire/reject`, body: input, auth: true });
    }
    /**
     * Approve a DRAFT version (four-eyes: the server refuses when the approver is the pack's author). On approval
     * the server publishes the country's policy settings (currency + locales + the capabilities/privacy captured
     * at registration); `policySettingsPublished` is how many became effective, making the country served.
     */
    approveCountryPack(countryCode, input) {
        return this.client.request({ method: 'POST', path: `/v1/config/country-packs/${encodeURIComponent(countryCode)}/approve`, body: input, auth: true });
    }
}
//# sourceMappingURL=config.js.map